angular.module('hcap-analytics').service('InvitesService', [
  '$http',
  '$state',
  '$q',
  'AssessmentService',
  'CohortsService',
  'UserService',
  'Util',
function(
  $http,
  $state,
  $q,
  AssessmentService,
  CohortsService,
  UserService,
  Util,
) {
  this.noticeCount = 0;
  this.taggedAssessments = [];
  this.unfinishedPhases = [];
  this.csmCohortInvites = [];

  this.update = () => {
    $q.all([
      AssessmentService.getUserDesignatedAssessments(),
      CohortsService.summary(),
    ]).then(res => {
      const userId = UserService.getUser()._id;
      this.taggedAssessments = Util.groupDesignatedAssessments(res[0]);
      this.csmCohortInvites = res[1]
        .filter(cohort => cohort.portal === 'CSM')
        .map(cohort => ({
          cohortId: cohort._id,
          cohortName: cohort.name,
          inviteUrl: cohort.csmInviteUrl,
        }));

      this.unfinishedPhases = res[1].reduce((acc, cohort) => {
        if (cohort.portal === 'CSM') {
          return acc;
        }

        const completion = cohort.team.members.find(m => m.id === userId).completion;

        for (let i = 0, len = cohort.phases.length; i < len; i++) {
          const phase = cohort.phases[i];
          const open = +phase.startDate <= +new Date() && +phase.dueDate >= +new Date();

          if (open &&
            (('setup' === phase.type && (!completion[i].charter || !completion[i].skills)) || !completion[i])
          ) {
            acc.push({
              cohortId: cohort._id,
              cohortName: cohort.name,
              phaseName: Util.phaseDisplay(i, cohort.phases),
              phaseIndex: i,
              dueDate: phase.dueDate,
            });
          }
        }

        return acc;
      }, []);

      const cohortInviteCount = $state.params.portal === 'CSM' ? this.csmCohortInvites.length : this.unfinishedPhases.length;
      this.noticeCount = this.taggedAssessments.length + cohortInviteCount;
    });
  };
}]);
